import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Card, Table, Badge } from 'react-bootstrap';
import { TrendingUp, Users, Award, ArrowUpRight, CheckCircle, ArrowUp, X } from 'lucide-react';
import '../../assets/css/ngodashboard/DonorManagement.css';
import NGOMasterLayout from '../../components/layout/NGOMasterLayout';
import axios from 'axios';
import AppContext from '../../context/AppContext';
import Swal from 'sweetalert2';

function DonorManagement() {
  const { baseUrl } = useContext(AppContext);

  const [allWithdrawals, setAllWithdrawals] = useState([]);
  const [selectedDonor,  setSelectedDonor]  = useState(null);
  const [donorRequest,   setDonorRequest]   = useState(null);
  const [toast,          setToast]          = useState(null);
  const [loading,        setLoading]        = useState(true);

  // ✅ FIX: Withdrawals fetch karo — yahi real donors hain
  useEffect(() => {
    axios.get(`${baseUrl}/donor/withdrawals`)
      .then((res) => {
        const data = Array.isArray(res.data)
          ? res.data
          : (res.data.data || res.data.withdrawals || []);
        setAllWithdrawals(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  // ✅ FIX: Level number ko "Level X" string mein convert karo display ke liye
  const getLevelLabel = (level) => {
    if (!level) return 'Level 1';
    if (String(level).startsWith('Level')) return level;
    return `Level ${level}`;
  };

  // ✅ FIX: Modal directly withdrawal record se kholo — name match ki zaroorat nahi
  const openWithdrawModal = (withdrawal) => {
    setDonorRequest(withdrawal);
    setSelectedDonor(withdrawal);
  };

  const closeModal = () => { setSelectedDonor(null); setDonorRequest(null); };
  const showToast  = (msg) => { setToast(msg); setTimeout(() => setToast(null), 3000); };

  const handleApprove = () => {
    Swal.fire({
      title: 'Approve Withdrawal?',
      text: `Approve Rs. ${Number(donorRequest?.payout).toLocaleString()} for ${donorRequest.name}?`,
      icon: 'question', showCancelButton: true,
      confirmButtonColor: '#1F7A7A', confirmButtonText: 'Yes, Approve',
    }).then((result) => {
      if (result.isConfirmed) {
        setAllWithdrawals((prev) =>
          prev.map((w) => w.id === donorRequest.id ? { ...w, status: 'Approved' } : w)
        );
        showToast(`✓ Withdrawal approved for ${donorRequest.name}`);
        closeModal();
        axios.post(`${baseUrl}/ngo/donors/approve`, { withdrawal_id: donorRequest?.id }).catch(() => {});
      }
    });
  };

  const handleReject = () => {
    Swal.fire({
      title: 'Reject Withdrawal?',
      text: `Reject request for ${donorRequest.name}?`,
      icon: 'warning', showCancelButton: true,
      confirmButtonColor: '#ef4444', confirmButtonText: 'Yes, Reject',
    }).then((result) => {
      if (result.isConfirmed) {
        setAllWithdrawals((prev) =>
          prev.map((w) => w.id === donorRequest.id ? { ...w, status: 'Rejected' } : w)
        );
        showToast(`✗ Withdrawal rejected for ${donorRequest.name}`);
        closeModal();
        axios.post(`${baseUrl}/ngo/donors/reject`, { withdrawal_id: donorRequest?.id }).catch(() => {});
      }
    });
  };

  // ✅ Level ke hisaab se card color
  const getModalHeaderCls = (level) => {
    const l = getLevelLabel(level);
    return l === 'Level 3' ? 'dm-modal-header-deep' :
           l === 'Level 2' ? 'dm-modal-header-mid'  : 'dm-modal-header-light';
  };

  const getLevelBadgeColor = (level) => {
    const l = getLevelLabel(level);
    return l === 'Level 1' ? 'secondary' : l === 'Level 2' ? 'info' : 'warning';
  };

  // ✅ Level count cards ke liye
  const countByLevel = (n) =>
    allWithdrawals.filter((w) => getLevelLabel(w.level) === `Level ${n}`).length;

  return (
    <NGOMasterLayout>
      <div className="dm-donor-mgmt-container">

        {/* Page Title */}
        <div className="dm-mgmt-page-title-section">
          <h1 className="dm-mgmt-page-heading">Donor Management</h1>
          <p className="dm-mgmt-page-subheading">Track and manage all donor activities</p>
        </div>

        {/* Level Cards */}
        <Row className="dm-donor-level-cards-row mb-4">
          {[
            { level:'Level 1', Icon:Users,     trend:'+12%', wrapCls:'',                    countCls:'',               trendCls:'',                n:1 },
            { level:'Level 2', Icon:Award,     trend:'+8%',  wrapCls:'',                    countCls:'',               trendCls:'',                n:2 },
            { level:'Level 3', Icon:TrendingUp,trend:'+15%', wrapCls:'dm-golden-highlight', countCls:'dm-golden-text', trendCls:'dm-golden-highlight', n:3 },
          ].map(({ level, Icon, trend, wrapCls, countCls, trendCls, n }) => (
            <Col lg={4} md={6} className="mb-3" key={level}>
              <Card className="dm-level-stat-card">
                <Card.Body>
                  <div className={`dm-level-card-icon-wrapper ${wrapCls}`}>
                    <Icon size={40} className="dm-level-card-icon" />
                  </div>
                  <div className="dm-level-card-details">
                    <h3 className={`dm-level-card-count ${countCls}`}>{countByLevel(n)}</h3>
                    <p className="dm-level-card-label">{level} Donors</p>
                    <div className={`dm-level-trend-indicator ${trendCls}`}>
                      <ArrowUpRight size={16}/><span>{trend} this month</span>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* All Donors Table */}
        <Card className="dm-donors-table-section-card mb-4">
          <Card.Body>
            <div className="dm-table-header-section">
              <h5 className="dm-table-section-heading"><Users size={20}/> All Withdrawal Requests</h5>
            </div>

            {/* Loading */}
            {loading && (
              <div style={{ textAlign: 'center', padding: '40px', color: '#1F7A7A' }}>
                Loading...
              </div>
            )}

            {/* No data */}
            {!loading && allWithdrawals.length === 0 && (
              <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
                📭 No withdrawal requests submitted yet.
              </div>
            )}

            {/* Table */}
            {!loading && allWithdrawals.length > 0 && (
              <div className="dm-table-wrapper-container">
                <Table hover responsive className="dm-donors-data-listing-table">
                  <thead style={{ background:'linear-gradient(90deg,#1F7A7A 0%,#165C5C 100%)' }}>
                    <tr>
                      {['#','Donor Name','Level','Account Type','Bank / Wallet','Amount','Status','Action'].map((h) => (
                        <th key={h} style={{ color:'#fff', fontWeight:600, textTransform:'uppercase', fontSize:13, letterSpacing:'0.7px', padding:'16px 14px', border:'none', whiteSpace:'nowrap', background:'transparent' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {allWithdrawals.map((w, index) => (
                      <tr key={w.id} className="dm-donor-table-data-row">
                        <td className="dm-donor-serial-number">{index + 1}</td>
                        <td className="dm-donor-name-column"><strong>{w.name}</strong></td>
                        <td className="dm-donor-level-column">
                          <Badge bg={getLevelBadgeColor(w.level)} className="dm-level-badge-pill">
                            {getLevelLabel(w.level)}
                          </Badge>
                        </td>
                        <td>{w.account_type || '—'}</td>
                        <td>{w.bank_name || w.wallet_number || '—'}</td>
                        <td style={{ fontWeight:700, color:'#1F7A7A' }}>
                          Rs. {Number(w.payout).toLocaleString()}
                        </td>
                        <td>
                          <Badge bg={w.status === 'Approved' ? 'success' : w.status === 'Rejected' ? 'danger' : 'warning'}>
                            {w.status || 'Pending'}
                          </Badge>
                        </td>
                        <td className="dm-donor-action-column">
                          <button
                            className="dm-withdraw-btn dm-withdraw-btn-review"
                            onClick={() => openWithdrawModal(w)}
                          >
                            <ArrowUp size={13}/> Review
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </Card.Body>
        </Card>

      </div>

      {/* WITHDRAWAL MODAL */}
      {selectedDonor && (
        <div className="dm-modal-backdrop" onClick={closeModal}>
          <div className="dm-modal-card" onClick={(e) => e.stopPropagation()}>

            <div className={`dm-modal-header ${getModalHeaderCls(donorRequest?.level)}`}>
              <div className="dm-modal-header-text">
                <h2 className="dm-modal-title">📋 Withdrawal Request</h2>
                <p className="dm-modal-subtitle">NGO Financial Management System</p>
              </div>
              <button className="dm-modal-close-btn" onClick={closeModal}><X size={20}/></button>
            </div>

            <div className="dm-modal-body">
              {/* Status Banner */}
              <div className={`dm-modal-status-banner dm-status-${(donorRequest.status || 'pending').toLowerCase()}`}>
                {donorRequest.status === 'Approved' ? '✅' : donorRequest.status === 'Rejected' ? '❌' : '⏳'}
                &nbsp;Request Status: <strong>{donorRequest.status || 'Pending'}</strong>
              </div>

              {/* Donor Name + Level */}
              <div className="dm-modal-info-row">
                <div className="dm-modal-info-box">
                  <label className="dm-modal-field-label">👤 Donor Name</label>
                  <div className="dm-modal-readonly">{donorRequest.name}</div>
                </div>
                <div className="dm-modal-info-box">
                  <label className="dm-modal-field-label"># Level</label>
                  <div className="dm-modal-readonly">{getLevelLabel(donorRequest.level)}</div>
                </div>
              </div>

              {/* Amount */}
              <div className="dm-modal-field-group">
                <label className="dm-modal-field-label">💰 Withdrawal Amount</label>
                <div className="dm-modal-readonly dm-modal-readonly-amount">
                  Rs. {Number(donorRequest.payout).toLocaleString()}
                </div>
              </div>

              <div className="dm-modal-section-divider">🏦 Account Details</div>

              {/* Account Type + Account Name */}
              <div className="dm-modal-info-row">
                <div className="dm-modal-info-box">
                  <label className="dm-modal-field-label">Account Type</label>
                  <div className="dm-modal-readonly">{donorRequest.account_type || '—'}</div>
                </div>
                <div className="dm-modal-info-box">
                  <label className="dm-modal-field-label">Account Name</label>
                  <div className="dm-modal-readonly">{donorRequest.account_name || '—'}</div>
                </div>
              </div>

              {/* Bank / Wallet + Reference */}
              <div className="dm-modal-info-row">
                <div className="dm-modal-info-box">
                  <label className="dm-modal-field-label">🏛 Bank / Wallet</label>
                  <div className="dm-modal-readonly">
                    {donorRequest.bank_name || donorRequest.wallet_number || '—'}
                  </div>
                </div>
                <div className="dm-modal-info-box">
                  <label className="dm-modal-field-label"># Transaction Reference</label>
                  <div className="dm-modal-readonly">{donorRequest.transaction_reference || '—'}</div>
                </div>
              </div>

              {/* Approve / Reject buttons */}
              {(!donorRequest.status || donorRequest.status === 'Pending') && (
                <div className="dm-modal-footer">
                  <button type="button" className="dm-modal-btn-reject"  onClick={handleReject}>✕ Reject</button>
                  <button type="button" className="dm-modal-btn-approve" onClick={handleApprove}>✓ Approve</button>
                </div>
              )}
              {donorRequest.status && donorRequest.status !== 'Pending' && (
                <div className="dm-modal-footer">
                  <button type="button" className="dm-modal-btn-cancel" onClick={closeModal}>Close</button>
                </div>
              )}
            </div>

          </div>
        </div>
      )}

      {/* Toast */}
      {toast && (
        <div className="dm-toast-notify">
          <CheckCircle size={18} className="dm-toast-icon"/> {toast}
        </div>
      )}

    </NGOMasterLayout>
  );
}

export default DonorManagement;